<template>
    <div class="menu--nav">
        <nav v-if="isClient">
            <ul>
                <li><menu-nav-item routing="dashboard"><translate>Konto Übersicht</translate></menu-nav-item></li>
                <li><menu-nav-item routing="offers"><translate>Angebote</translate></menu-nav-item></li>
                <li><menu-nav-item routing="orders"><translate>Bestellungen</translate></menu-nav-item></li>
                <li><menu-nav-item routing="quotes"><translate>Anfragen</translate></menu-nav-item></li>
            </ul>
        </nav>
        <nav v-if="!isClient">
            <ul>
                <li><menu-nav-item routing="dashboard"><translate>Konto Übersicht</translate></menu-nav-item></li>
                <li><menu-nav-item routing="quotes"><translate>Anfragen</translate></menu-nav-item></li>
                <li><menu-nav-item routing="offers"><translate>Angebote</translate></menu-nav-item></li>
                <li><menu-nav-item routing="orders"><translate>Aufträge</translate></menu-nav-item></li>
            </ul>
        </nav>
    </div>
</template>

<script>

import MenuNavItem from './MenuNavItem';

export default {
    name: 'MenuNav',
    components: {MenuNavItem},
    computed: {
        isClient() {
            return this.$page.props.routePrefix === 'client';
        },
    }
};
</script>
